import { render } from "./AdminSessionDetail.vue?vue&type=template&id=138dad4d&scoped=true"
import script from "./AdminSessionDetail.vue?vue&type=script&lang=js"
export * from "./AdminSessionDetail.vue?vue&type=script&lang=js"

import "./AdminSessionDetail.vue?vue&type=style&index=0&id=138dad4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138dad4d"]])

export default __exports__